module.exports = __webpack_public_path__ + "static/media/slimelab.4efd2a58.png";